module.exports = __webpack_public_path__ + "img/image_2022_07_25T09_11_05_514Z.57991aea.png";